// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, addToChainBefore, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchUpdateWishListLine,
    RequestUpdateWishListLine,
} from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/UpdateWishListLine";
import { WishListLineModel } from "@insite/client-framework/Types/ApiModels";
import { xCommonUpdate } from "@plumberssupply/App/Handlers/XNG/Common";

export const DispatchBeginRoundToBoxLoading: typeof RequestUpdateWishListLine = props => {
    if ((props.parameter as any).updatedKey === "roundToBox") {
        props.dispatch(
            xCommonUpdate({ key: "isRoundToBoxLoading", value: { [props.parameter.wishListLineId]: true } }),
        );
    }
};

export const XDispatchUpdateWishListLine: typeof DispatchUpdateWishListLine = props => {
    if ((props.parameter as any).updatedKey === "roundToBox") {
        const wishListLineResult = props.result.wishListLine || ({ properties: {} } as WishListLineModel);
        const newWishListValue: WishListLineModel = {
            ...props.parameter.wishListLine,
            ...wishListLineResult,
            properties: {
                ...props.parameter.wishListLine.properties,
                ...wishListLineResult.properties,
            },
        };
        if (props.result.wishListLine) {
            props.dispatch({
                type: "Data/WishListLines/UpdateWishListLine",
                model: newWishListValue,
            });
        }
        return;
    }

    DispatchUpdateWishListLine(props);
};

export const DispatchCompleteRoundToBoxLoading: typeof RequestUpdateWishListLine = props => {
    if ((props.parameter as any).updatedKey === "roundToBox") {
        props.dispatch(
            xCommonUpdate({ key: "isRoundToBoxLoading", value: { [props.parameter.wishListLineId]: false } }),
        );
    }
};

addToChainBefore(chain, RequestUpdateWishListLine, DispatchBeginRoundToBoxLoading);
replaceInChain(chain, DispatchUpdateWishListLine, XDispatchUpdateWishListLine);
addToChainAfter(chain, RequestUpdateWishListLine, DispatchCompleteRoundToBoxLoading);
